export default __webpack_public_path__ + "static/media/name.a414384a.svg";